// extracted by mini-css-extract-plugin
module.exports = {"TitleSection":"ForgotPassword__TitleSection__2QId"};